export default "__VITE_ASSET__CpFf1iSr__"